const SECTION_NAMES = {
    'A' : "Stainless Steel Hose Kits: Two (2) 2' or 3' Braided Hoses with Automatic Flow Control, Shut-Off Valves and  PT Plugs",
    'B' : "Stainless Steel Hose Kits: Two (2) 2' or 3' Braided Hoses with Manual Balance, Shut-Off Valves w/ Memory Stop and PT Plugs",
    'C' : 'Stainless Steel Hoses ONLY - 36" Length (2 Required per Heat Pump)'
}

const FEET_OPTIONS = [
    {'feet' : '2', 'id' : '7602', 'sections' : ['A', 'B']},
    {'feet' : '3', 'id' : '7603', 'sections' : ['A', 'B', 'C']}
]

const OPTIONS = {

    'HBH006' : {'connection' : '1/2"', 'options' : {'A':[
                {'id' : '135015', 'afr' : '1.5', 'pt' : '3.0'},
                {'id' : '135020', 'afr' : '2.0', 'pt' : '4.0'}
            ], 'B':[
                {'id' : '130'}
            ], 'C':[
            ]}},
    'HBV006' : {'connection' : '1/2"', 'options' : {'A':[
                {'id' : '135015', 'afr' : '1.5', 'pt' : '3.0'},
                {'id' : '135020', 'afr' : '2.0', 'pt' : '4.0'}
            ], 'B':[
                {'id' : '130'}
            ], 'C':[
            ]}},

    'HBH009' : {'connection' : '1/2"', 'options' : {'A':[
                {'id' : '135015', 'afr' : '1.5', 'pt' : '2.0'},
                {'id' : '135020', 'afr' : '2.0', 'pt' : '2.7'},
                {'id' : '135030', 'afr' : '3.0', 'pt' : '4.0'}
            ], 'B':[
                {'id' : '130'}
            ], 'C':[]
        }},
    'HBV009' : {'connection' : '1/2"', 'options' : {'A':[
                {'id' : '135015', 'afr' : '1.5', 'pt' : '2.0'},
                {'id' : '135020', 'afr' : '2.0', 'pt' : '2.7'},
                {'id' : '135030', 'afr' : '3.0', 'pt' : '4.0'}
            ], 'B':[
                {'id' : '130'}
            ], 'C':[]
        }},

    'HBH012' : {'connection' : '1/2"', 'options' : {'A':[
                {'id' : '135020', 'afr' : '2.0', 'pt' : '2.0'},
                {'id' : '135030', 'afr' : '3.0', 'pt' : '3.0'},
                {'id' : '135050', 'afr' : '5.0', 'pt' : '5.0'}

            ], 'B':[
                {'id' : '130'}
            ], 'C':[]
        }},
    'HBV012' : {'connection' : '1/2"', 'options' : {'A':[
                {'id' : '135020', 'afr' : '2.0', 'pt' : '2.0'},
                {'id' : '135030', 'afr' : '3.0', 'pt' : '3.0'},
                {'id' : '135050', 'afr' : '5.0', 'pt' : '5.0'}

            ], 'B':[
                {'id' : '130'}
            ], 'C':[]
        }},

    'HBH015' : {'connection' : '1/2"', 'options' : {'A':[
                {'id' : '135030', 'afr' : '3.0', 'pt' : '2.4'},
                {'id' : '135050', 'afr' : '5.0', 'pt' : '4.0'}
            ], 'B':[
                {'id' : '130'}
            ], 'C':[]
        }},
    'HBV015' : {'connection' : '1/2"', 'options' : {'A':[
                {'id' : '135030', 'afr' : '3.0', 'pt' : '2.4'},
                {'id' : '135050', 'afr' : '5.0', 'pt' : '4.0'}
            ], 'B':[
                {'id' : '130'}
            ], 'C':[]
        }},

    'HBH018' : {'connection' : '1/2"', 'options' : {'A':[
                {'id' : '135030', 'afr' : '3.0', 'pt' : '2.0'},
                {'id' : '135050', 'afr' : '5.0', 'pt' : '3.3'}
            ], 'B':[
                {'id' : '130'}
            ], 'C':[]
        }},
    'HBV018' : {'connection' : '1/2"', 'options' : {'A':[
                {'id' : '135030', 'afr' : '3.0', 'pt' : '2.0'},
                {'id' : '135050', 'afr' : '5.0', 'pt' : '3.3'}
            ], 'B':[
                {'id' : '130'}
            ], 'C':[]
        }},

    'HBH024' : {'connection' : '3/4"', 'options' : {'A':[
                {'id' : '131060', 'afr' : '6.0', 'pt' : '3.0'},
                {'id' : '131080', 'afr' : '8.0', 'pt' : '4.0'}
            ], 'B':[
                {'id' : '131'}
            ], 'C':[
                {'id' : '7603-101'}
            ],}},
    'HBV024' : {'connection' : '3/4"', 'options' : {'A':[
                {'id' : '131060', 'afr' : '6.0', 'pt' : '3.0'},
                {'id' : '131080', 'afr' : '8.0', 'pt' : '4.0'}
            ], 'B':[
                {'id' : '131'}
            ], 'C':[
                {'id' : '7603-101'}
            ],}},

    'HBH030' : {'connection' : '3/4"', 'options' : {'A':[
                {'id' : '131060', 'afr' : '6.0', 'pt' : '2.4'},
                {'id' : '131080', 'afr' : '8.0', 'pt' : '3.2'},
                {'id' : '131090', 'afr' : '9.0', 'pt' : '3.6'},
                {'id' : '131100', 'afr' : '10.0', 'pt' : '4.0'}
            ], 'B':[
                {'id' : '131'}
            ], 'C':[
                {'id' : '7603-101'}
            ]}},
    'HBV030' : {'connection' : '3/4"', 'options' : {'A':[
                {'id' : '131060', 'afr' : '6.0', 'pt' : '2.4'},
                {'id' : '131080', 'afr' : '8.0', 'pt' : '3.2'},
                {'id' : '131090', 'afr' : '9.0', 'pt' : '3.6'},
                {'id' : '131100', 'afr' : '10.0', 'pt' : '4.0'}
            ], 'B':[
                {'id' : '131'}
            ], 'C':[
                {'id' : '7603-101'}
            ]}},

    'HBH036' : {'connection' : '3/4"', 'options' : {'A':[
                {'id' : '131060', 'afr' : '6.0', 'pt' : '2.0'},
                {'id' : '131080', 'afr' : '8.0', 'pt' : '2.7'},
                {'id' : '131090', 'afr' : '9.0', 'pt' : '3.0'},
                {'id' : '131100', 'afr' : '10.0', 'pt' : '3.3'}
            ], 'B':[
                {'id' : '131'}
            ], 'C':[
                {'id' : '7603-101'}
            ]}},
    'HBV036' : {'connection' : '3/4"', 'options' : {'A':[
                {'id' : '131060', 'afr' : '6.0', 'pt' : '2.0'},
                {'id' : '131080', 'afr' : '8.0', 'pt' : '2.7'},
                {'id' : '131090', 'afr' : '9.0', 'pt' : '3.0'},
                {'id' : '131100', 'afr' : '10.0', 'pt' : '3.3'}
            ], 'B':[
                {'id' : '131'}
            ], 'C':[
                {'id' : '7603-101'}
            ]}},

    'HBH042' : {'connection' : '3/4"', 'options' : {'A':[
                {'id' : '131080', 'afr' : '8.0', 'pt' : '2.3'},
                {'id' : '131090', 'afr' : '9.0', 'pt' : '2.6'},
                {'id' : '131100', 'afr' : '10.0', 'pt' : '2.9'}
            ], 'B':[
                {'id' : '131'}
            ], 'C':[
                {'id' : '7603-101'}
            ]}},
    'HBV042' : {'connection' : '3/4"', 'options' : {'A':[
                {'id' : '131080', 'afr' : '8.0', 'pt' : '2.3'},
                {'id' : '131090', 'afr' : '9.0', 'pt' : '2.6'},
                {'id' : '131100', 'afr' : '10.0', 'pt' : '2.9'}
            ], 'B':[
                {'id' : '131'}
            ], 'C':[
                {'id' : '7603-101'}
            ]}},

    'HBH048' : {'connection' : '1"', 'options' : {'A':[
                {'id' : '132120', 'afr' : '12.0', 'pt' : '3.0'},
                {'id' : '132150', 'afr' : '15.0', 'pt' : '3.8'},
                {'id' : '132180', 'afr' : '18.0', 'pt' : '4.5'}
            ], 'B':[
                {'id' : '132'}
            ], 'C':[
                {'id' : '7603-100'}
            ]}},
    'HBV048' : {'connection' : '1"', 'options' : {'A':[
                {'id' : '132120', 'afr' : '12.0', 'pt' : '3.0'},
                {'id' : '132150', 'afr' : '15.0', 'pt' : '3.8'},
                {'id' : '132180', 'afr' : '18.0', 'pt' : '4.5'}
            ], 'B':[
                {'id' : '132'}
            ], 'C':[
                {'id' : '7603-100'}
            ]}},

    'HBH060' : {'connection' : '1"', 'options' : {'A':[
                {'id' : '132120', 'afr' : '12.0', 'pt' : '2.4'},
                {'id' : '132150', 'afr' : '15.0', 'pt' : '3.0'},
                {'id' : '132180', 'afr' : '18.0', 'pt' : '3.6'}
            ], 'B':[
                {'id' : '132'}
            ], 'C':[
                {'id' : '7603-100'}
            ]}},
    'HBV060' : {'connection' : '1"', 'options' : {'A':[
                {'id' : '132120', 'afr' : '12.0', 'pt' : '2.4'},
                {'id' : '132150', 'afr' : '15.0', 'pt' : '3.0'},
                {'id' : '132180', 'afr' : '18.0', 'pt' : '3.6'}
            ], 'B':[
                {'id' : '132'}
            ], 'C':[
                {'id' : '7603-100'}
            ]}},

    'HBH072' : {'connection' : '1-1/4"', 'options' : {'A':[
                {'id' : '133180', 'afr' : '18.0', 'pt' : '3.0'},
                {'id' : '133200', 'afr' : '20.0', 'pt' : '3.3'},
                {'id' : '133300', 'afr' : '30.0', 'pt' : '5.0'}
            ], 'B':[
                {'id' : '133'}
            ], 'C':[]
        }},
    'HBH096' : {'connection' : '1-1/4"', 'options' : {'A':[
                {'id' : '133180', 'afr' : '18.0', 'pt' : '2.3'},
                {'id' : '133200', 'afr' : '20.0', 'pt' : '2.5'},
                {'id' : '133300', 'afr' : '30.0', 'pt' : '3.8'}
            ], 'B':[
                {'id' : '133'}
            ], 'C':[]
        }},
    'HKV084' : {'connection' : '1-1/2"', 'options' : {'A':[
                {'id' : '134200', 'afr' : '20.0', 'pt' : '3.0'},
                {'id' : '134300', 'afr' : '30.0', 'pt' : '4.5'}
            ], 'B':[
                {'id' : '134'}
            ], 'C':[]
        }},
    'HKV096' : {'connection' : '1-1/2"', 'options' : {'A':[
                {'id' : '134200', 'afr' : '20.0', 'pt' : '2.4'},
                {'id' : '134300', 'afr' : '30.0', 'pt' : '3.6'},
                {'id' : '134400', 'afr' : '40.0', 'pt' : '4.8'}
            ], 'B':[
                {'id' : '134'}
            ], 'C':[]
        }},

    'HBH120' : {'connection' : '1-1/2"', 'options' : {'A':[
                {'id' : '134200',  'afr' : '20.0', 'pt' : '2.0'},
                {'id' : '134300',  'afr' : '30.0', 'pt' : '3.0'},
                {'id' : '134400',  'afr' : '40.0', 'pt' : '4.0'}
            ], 'B':[
                {'id' : '134'}
            ], 'C':[]
        }},
    'HKV120' : {'connection' : '1-1/2"', 'options' : {'A':[
                {'id' : '134200',  'afr' : '20.0', 'pt' : '2.0'},
                {'id' : '134300',  'afr' : '30.0', 'pt' : '3.0'},
                {'id' : '134400',  'afr' : '40.0', 'pt' : '4.0'}
            ], 'B':[
                {'id' : '134'}
            ], 'C':[]
        }},

    'HKV150' : {'connection' : '1-1/2"', 'options' : {'A':[
                {'id' : '134300', 'afr' : '30.0', 'pt' : '2.3'},
                {'id' : '134400', 'afr' : '40.0', 'pt' : '3.0'},
                {'id' : '134500', 'afr' : '50.0', 'pt' : '3.8'}

            ], 'B':[
                {'id' : '134'}
            ], 'C':[]
        }},

    'HKV168' : {'connection' : '1-1/2"', 'options' : {'A':[
                {'id' : '134300', 'afr' : '30.0', 'pt' : '2.3'},
                {'id' : '134400', 'afr' : '40.0', 'pt' : '3.0'},
                {'id' : '134500', 'afr' : '50.0', 'pt' : '3.8'}

            ], 'B':[
                {'id' : '134'}
            ], 'C':[]
        }},

    'HKV192' : {'connection' : '1-1/2"', 'options' : {'A':[
                {'id' : '134300', 'afr' : '30.0', 'pt' : '1.8'},
                {'id' : '134400', 'afr' : '40.0', 'pt' : '2.4'},
                {'id' : '134500', 'afr' : '50.0', 'pt' : '3.0'},
                {'id' : '134600', 'afr' : '60.0', 'pt' : '3.6'}
            ], 'B':[
                {'id' : '134'}
            ], 'C':[]
        }},
    'HKV240' : {'connection' : '1-1/2"', 'options' : {'A':[
                {'id' : '134400', 'afr' : '40.0', 'pt' : '2.0'},
                {'id' : '134500', 'afr' : '50.0', 'pt' : '2.5'},
                {'id' : '134600', 'afr' : '60.0', 'pt' : '3.0'}
            ], 'B':[
                {'id' : '134'}
            ], 'C':[]
        }},
    'HKV300' : {'connection' : '1-1/2"', 'options' : {'A':[
                {'id' : '134500', 'afr' : '50.0', 'pt' : '2.0'},
                {'id' : '134600', 'afr' : '60.0', 'pt' : '2.0'}
            ], 'B':[
                {'id' : '134'}
            ], 'C':[]
        }}
};

function select (serial) {

    if (! OPTIONS[serial]) {
        return false;
    }

    let serialOptions = OPTIONS[serial];
    let availableOptions = {'2' : {'A' : {}, 'B' : {}, 'C': {}}, '3' : {'A' : {}, 'B' : {}, 'C' : {}}};

    for (let feetOptions of FEET_OPTIONS) {
        let feetType = feetOptions.feet;
        let sectionOptions = availableOptions[feetType];

        for (let sectionId of feetOptions.sections) {
            sectionOptions[sectionId].name = SECTION_NAMES[sectionId];
            sectionOptions[sectionId].options = [];

            let options = sectionOptions[sectionId].options;

            for (let option of serialOptions.options[sectionId]) {
                let row = {};
                if (sectionId == 'C') {
                    row.serial = option.id;
                    row.description = [serialOptions.connection, 'Hose'].join(' ');
                } else {
                    row.serial = feetOptions.id + '-' + option.id;
                    if (sectionId == 'A') {
                        row.description = [serialOptions.connection, option.pt, 'GPM/Ton'].join(' ');
                    } else {
                        // B
                        row.description = [serialOptions.connection, 'Manual'].join(' ');
                    }
                }

                options.push(row);
            }
        }
    }

    // ----------------------------------------------------------------------------------------------------------------
    // ----------------------------------------------------------------------------------------------------------------
    // ----------------------------------------------------------------------------------------------------------------

    // transform available options
    let transformedOptions = {}

    if (availableOptions['2']['A'].options.length > 0 || availableOptions['3']['A'].options.length > 0) {
        transformedOptions['A'] = {
            'description': (availableOptions['2']['A'].name || availableOptions['3']['A'].name),
            '2-foot': availableOptions['2']['A'].options,
            '3-foot': availableOptions['3']['A'].options
        }
    }

    if (availableOptions['2']['B'].options.length > 0 || availableOptions['3']['B'].options.length > 0) {
        transformedOptions['B'] = {
            'description': (availableOptions['2']['B'].name || availableOptions['3']['B'].name),
            '2-foot': availableOptions['2']['B'].options,
            '3-foot': availableOptions['3']['B'].options
        }
    }

    if (/* availableOptions['2']['C'].options.length > 0 || */ availableOptions['3']['C'].options.length > 0) {
        transformedOptions['C'] = {
            'description': (/* availableOptions['2']['C'].name || */availableOptions['3']['C'].name),
            '2-foot': [], // availableOptions['2']['C'].options,
            '3-foot': availableOptions['3']['C'].options
        }
    }

    // ----------------------------------------------------------------------------------------------------------------
    // ----------------------------------------------------------------------------------------------------------------
    // ----------------------------------------------------------------------------------------------------------------


    return transformedOptions
}

module.exports = { select }
